import Carousel from 'nuka-carousel'
import classNames from 'classnames'
import { Endorsement } from 'components/home/Endorsements'
import PartnersPanel from 'components/partners/PartnersPanel'
import styles from './styles/Endorsements.css'

const Endorsements = ({ className, subheader = `Over ${CONFIG.userCount} students, researchers, and industry experts use scite`, studentEndorsements = true }) => (
  <div className={classNames(styles.endorsementContainer, className)}>
    <PartnersPanel wideLayout header='Trusted by researchers and organizations around the world' subheader={subheader} studentEndorsements={studentEndorsements} />
    <div className={styles.carousel}>
      <Carousel
        slidesToScroll={1}
        slidesToShow={1}
        dragging
        wrapAround
        heightMode='current'
        framePadding='2rem'
        autoplay
        autoplayInterval={4000}
        renderCenterLeftControls={({ previousSlide }) => (
          <div onClick={previousSlide}><i className='fa fa-arrow-left' /></div>
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <div onClick={nextSlide}><i className='fa fa-arrow-right' /></div>
        )}
        defaultControlsConfig={{
          pagingDotsStyle: {
            transform: 'translateY(250%)'
          }
        }}
      >
        <Endorsement
          img={`${CONFIG.assetsBaseURL}/images/endorsements/emir-efendic.png`}
          name='Emir Efendić, Ph.D'
          affiliation='Maastricht University'
          className={styles.endorsement}
        >
          scite is an incredibly clever tool. The feature that classifies papers on whether they find supporting or contrasting evidence for a particular publication saves so much time. It has become indispensable to me when writing papers and finding related work to cite and read.
        </Endorsement>
        <Endorsement
          lazy
          img={`${CONFIG.assetsBaseURL}/images/endorsements/kate.png`}
          name='Kathleen C McCormick, Ph.D Student'
          affiliation='Cornell'
          className={styles.endorsement}
        >
          As a PhD student, I'm so glad that this exists for my literature searches and papers. Being able to assess what is disputed or affirmed in the literature is how the scientific process is supposed to work, and scite helps me do this more efficiently.
        </Endorsement>
        <Endorsement
          img={`${CONFIG.assetsBaseURL}/images/endorsements/mark.png`}
          name='Mark Mikkelsen, Ph.D'
          affiliation='The Johns Hopkins University School of Medicine'
          className={styles.endorsement}
        >
          scite is such an awesome tool! It’s never been easier to place a scientific paper in the context of the wider literature.
        </Endorsement>
        <Endorsement
          img={`${CONFIG.assetsBaseURL}/images/endorsements/david-fisman.png`}
          name='David N. Fisman, Ph.D'
          affiliation='University of Toronto'
          className={styles.endorsement}
        >
          This is a really cool tool. I just tried it out on a paper we wrote on flu/pneumococcal seasonality...
          really interesting to see the results were affirmed by other studies. I had no idea.
        </Endorsement>
      </Carousel>
    </div>
  </div>
)

export default Endorsements
